export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /Users/Guest/Desktop/nurture/src/environments/environment.ts